import { DayPicker } from 'components/DayPicker/DayPicker';
import { useRescheduleState } from 'domains/direct-reschedule/useRescheduleProvider';

type Props = {
  onChange: (dayIndex: number) => void;
  selectedDayIndex?: number;
  maxDay?: Date;
};
export const PaginatedDayPicker = ({ onChange, selectedDayIndex, maxDay }: Props) => {
  const {
    availableTimesQuery: { fetchNextPage, isFetching },
    availableTimes,
  } = useRescheduleState();

  const onScroll = async () => {
    await fetchNextPage({
      pageParam: availableTimes[availableTimes.length - 1].day.toISOString(),
    });
  };

  return (
    <DayPicker
      onChange={onChange}
      availableTimes={availableTimes}
      onInfiniteScroll={onScroll}
      isScrollLoading={isFetching}
      selectedDayIndex={selectedDayIndex}
      maxDay={maxDay}
    />
  );
};
